export const SET_APPOINTMENT_ID = "SET_APPOINTMENT_ID";
export const SET_USER_PREFERENCE = "SET_USER_PREFERENCE";
export const SET_SESSION_TYPE = "SET_SESSION_TYPE";
export const SET_SESSION_STUDENT = "SET_SESSION_STUDENT";
export const SET_SESSION_DURATION = "SET_SESSION_DURATION";
export const SET_SESSION_REMAINING_HOUR = "SET_SESSION_REMAINING_HOUR";
export const SET_APPOINTMENT_FOR = "SET_APPOINTMENT_FOR";
export const SET_SESSION_DATE = "SET_SESSION_DATE";
export const SET_SESSION_START_TIME = "SET_SESSION_START_TIME";
export const SET_COMMENT = "SET_COMMENT";
export const SET_NOTES = "SET_NOTES";
export const SET_PRACTICE_WORK_GIVEN = "SET_PRACTICE_WORK_GIVEN";
export const SET_NEXT_DATE = "SET_NEXT_DATE";
export const SET_SHOW_REPORT_BUTTON = "SET_SHOW_REPORT_BUTTON";
export const SET_PRACTICE_WORK_GIVEN_DETAIL = "SET_PRACTICE_WORK_GIVEN_DETAIL";
export const SET_SESSION_END_TIME = "SET_SESSION_END_TIME";
export const RESET_SESSION_DATA = "RESET_SESSION_DATA"; // 🔄 Reset Action
